// extracted by mini-css-extract-plugin
export default {"popup":"H2yJgsXhQqeY1IsHcEff","grayContainer":"Pt80XqtJUkMPzYt8aBFA","list":"CqtpDA7SLgbHeSdp2vIx","listItem":"VdHHLc6eFuZHiB5tLT9v","roundedBtnImage":"pw2qH7LRYKNKPPaGTj42"};